import React from 'react';
import DaumPostcode from 'react-daum-postcode';
import close from './img/bi_x.png'

const postCodeStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    border: "1px solid #000000",
    maxWidth: "700px",
    maxHeight: "500px",
    zIndex:'111'
};

const postClose = {
  borderBottom:'1px solid black',
  height:'30px',
  textAlign:'right',
  padding:'4px 7px',
  background:'#F3F3F3'
}

const closeImage = {
  fontSize:'19px',
  lineHeight:'19px'
}

const Postcode = ({inputs,setInputs,isPost,setIsPost}) => {
  
  const handleComplete = (data) => {
    let fullAddress = data.address;
    let extraAddress = ''; 
      console.log('data', data);
    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
      }
      fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
    }
  
    console.log(fullAddress);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
    setInputs({
      ...inputs,
      u_address1:fullAddress,
      u_sa_address_1:data.zonecode,
      u_sa_address_2:fullAddress
    });

    setIsPost(!isPost);
    
  }


  const closePost = () => {
    setIsPost(!isPost);
  }

  return (
    <div style={postCodeStyle}>
      <div style={postClose}>
        <span style={closeImage} onClick={closePost}>X</span>
      </div>
      <DaumPostcode
        onComplete={handleComplete}
        autoClose
      />
    </div>
  );
}


export default Postcode;